import { CustomTextField } from '../../../../../components/CustomTextField';
import { Box, MenuItem } from '@mui/material';
import { CustomSelectAndChildren } from '../../../../../components/CustomSelectAndChildren';
import CustomChipAutocomplete from './../../../../../components/CustomChipAutocomplete';
import { status, STATUS_MODEL } from '../../../../../enums/statusEnum';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
import { CleanIcon } from '../../../../../components/buttons/IconButtons';
import { categoryToChipOption } from '../Model/Model';
import { handleAutocompleteKeyDown } from '../Functionality/CommonEquipmentMaterialApp';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const GeneralDetailsStep = ({
    item,
    disabled,
    emptyFields,
    handleChange,
    t,
    selectedCategory,
    setSelectedCategory,
    selectedSubCategory,
    setSelectedSubCategory,
    dispatch,
    handleClearFields,
    createSubcategoryBody,
    createCategoryBody,
    handleCreate,
    handleSearchSubcategory,
    handleSearchCategory,
    categoryOptions,
    setCategoryOptions,
    subCategoryOptions,
    setSubCategoryOptions,
}) => {

    return (
        <>
            {!item?.id && (
                <div className='row d-flex justify-content-end m-3'>
                    <ButtonIcon
                        id='btn_gds_clean_fields'
                        Icon={CleanIcon}
                        onClick={handleClearFields}
                        title={'clear_instances'}
                        className={'btn-clean-secondary-600'}
                        tooltipPlacement={'right'}
                        iconProps='btn-icon-svg-12px icon-color-general-00'
                    />
                </div>
            )}
            <div className='row'>
                <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                    <CustomTextField
                        id='txt_gds_code'
                        name='name'
                        value={item?.name}
                        trans='name'
                        type={'text'}
                        disabled={disabled}
                        onChange={handleChange}
                        emptyFields={emptyFields}
                        required={true}
                        length={128}
                        placeholder={t('enter_equipment_name')}
                    />
                </div>
                <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6'>
                    <CustomTextField
                        id='txt_gds_code'
                        name='code'
                        value={item?.code}
                        trans='code'
                        type={'text'}
                        disabled={disabled}
                        onChange={handleChange}
                        emptyFields={emptyFields}
                        required={true}
                        length={128}
                        placeholder={t('enter_equipment_code')}
                    />
                </div>
            </div>
            {item?.id && (
                <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6'>
                    <CustomSelectAndChildren
                        id='slt_gds_status'
                        name='statusId'
                        trans='status'
                        disabled={disabled}
                        onChange={handleChange}
                        value={item?.statusId || ''}
                        emptyFields={emptyFields}
                        required={true}
                        showNoSelectionOption={false}
                    >
                        {[{ id: STATUS_MODEL.ACTIVE }, { id: STATUS_MODEL.INACTIVE }].map((st, index) => (
                            <MenuItem key={index} value={st.id}>
                                {t(status[st.id])}
                            </MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </div>
            )}
            <div className='col-sm-12 col-md-6 px-0'>
                <div className={"row"}>
                    <Box className='col-sm-12 col-md-3'>
                        <p className='fs-14px ibl-font-w-400 ibl-font-w-600'>{t('category')}</p>
                    </Box>
                    <Box className='col-sm-12 col-md-9'>
                        <CustomChipAutocomplete
                            options={categoryOptions}
                            setOptions={setCategoryOptions}
                            value={selectedCategory}
                            onChange={setSelectedCategory}
                            getOptionLabel={(opt) => opt.label}
                            placeholder={t('select_create_category')}
                            rowsPerPage={20}
                            dispatch={dispatch}
                            optionKey='name'
                            maxLength={1}
                            maxChar={128}
                            transformFn={categoryToChipOption}
                            createBody={createCategoryBody}
                            onSearch={handleSearchCategory}
                            onKeyDown={handleAutocompleteKeyDown({
                                createBody: createCategoryBody,
                                onCreate: handleCreate,
                                value: selectedCategory,
                                onChange: setSelectedCategory,
                                t
                            })}
                        />
                    </Box>
                </div>
            </div>

            <div className="col-sm-12 col-md-6 px-0">
                <div className={"row"}>
                    <Box className='col-sm-12 col-md-3'>
                        <p className='fs-14px ibl-font-w-400 ibl-font-w-600'>{t('subcategory')}</p>
                    </Box>
                    <Box className='col-sm-12 col-md-9'>
                        <CustomChipAutocomplete
                            options={subCategoryOptions}
                            setOptions={setSubCategoryOptions}
                            value={selectedSubCategory}
                            onChange={setSelectedSubCategory}
                            getOptionLabel={(opt) => opt.label}
                            placeholder={t('select_create_subcategory')}
                            rowsPerPage={20}
                            dispatch={dispatch}
                            optionKey='name'
                            transformFn={categoryToChipOption}
                            createBody={createSubcategoryBody}
                            onSearch={handleSearchSubcategory}
                            maxLength={1}
                            maxChar={128}
                            onKeyDown={handleAutocompleteKeyDown({
                                createBody: createSubcategoryBody,
                                onCreate: handleCreate,
                                value: selectedSubCategory,
                                onChange: setSelectedSubCategory,
                                t
                            })}
                        />
                    </Box>
                </div>
            </div>
        </>
    );
};

export default GeneralDetailsStep;
